import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-07d5d6b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" })
], -1))
const _hoisted_2 = { class: "tab-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" })
], -1))
const _hoisted_4 = { class: "tab-title" }

import { ref } from 'vue';
import UploadFileImages from "@/components/upload/UploadFileImages.vue";
import GalaxyUpload from "@/components/galaxy/Galaxy.vue";

interface Props {
  apiImages: any,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GalaxyImage',
  props: {
    apiImages: { default: '' }
  },
  emits: ["close", "uploadImages", "choiceBanner"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const activeKey = ref('1');
const emit = __emit;

const uploadImages = (images: any) => {
  emit("uploadImages", images);
};

const choiceBanner = (images: any) => {
  // clone tránh reactive side-effect
  const data = JSON.parse(JSON.stringify(images));
  emit("choiceBanner", data);
};

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    activeKey: activeKey.value,
    "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tab_pane, { key: "1" }, {
        tab: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('text.imageList')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(GalaxyUpload, {
            apiImages: props.apiImages,
            onChoiceBanner: choiceBanner
          }, null, 8, ["apiImages"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_tab_pane, { key: "2" }, {
        tab: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('text.uploadImage')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(UploadFileImages, { onUploadImages: uploadImages })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["activeKey"]))
}
}

})